import { render, staticRenderFns } from "./PainelObcoop.vue?vue&type=template&id=3f05adfb"
import script from "./PainelObcoop.vue?vue&type=script&lang=js"
export * from "./PainelObcoop.vue?vue&type=script&lang=js"
import style0 from "./PainelObcoop.vue?vue&type=style&index=0&id=3f05adfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports